import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSiteInspectionBookingByFolderId } from "../../Api/SiteInspectionBooking/SiteInspectionBookingApiServices";
import { mapSiteInspectionBookingLists } from "../Types/SiteInspectionBooking/SiteInspectionBookingTypes";

// Fetch site inspection booking
export const fetchSiteInspectionBooking = createAsyncThunk(
    'fetchSiteInspectionBooking', async (folder_id: number, { rejectWithValue }) => {
        try {
            // api
            const response = await getSiteInspectionBookingByFolderId(folder_id);
            if (response.status) {
                return mapSiteInspectionBookingLists(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch site inspection bookings');
        }
    }
);